import { PageHeader } from "@/shared/ui/PageHeader";

export function ReportPage() {
  return (
    <section>
      <PageHeader
        eyebrow="Report"
        title="Investor report"
        subtitle="Feature slice placeholder — migrate frontend/app/report.html here."
      />
    </section>
  );
}